import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
    state: {
        requestListing: [],
        requestDetail: {},
        productRequestListing: [],
        requestSummary: {}
    },
    getters: {
        getRequestListing: (state) => state.requestListing,
        getRequestDetail: (state) => state.requestDetail,
        getProductRequestListing: (state) => state.productRequestListing,
        getRequestSummary: (state) => state.requestSummary,
    },
    actions: {
        getServiceRequestListing({commit},role){
            return new Promise((resolve,reject) => {
              axios.get(`${BASE_URL}/servicerequest/listing/${role}`).then((response) => {
                commit("setRequestListing",response.data.data)
                commit("setRequestSummary",response.data.summary)
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
        },
        getServiceRequestListingByProduct({commit}, product_code){
            return new Promise((resolve,reject) => {
              axios.get(`${BASE_URL}/servicerequest/product/${product_code}`).then((response) => {
                commit("setProductRequestListing",response.data.data)
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
        },
        getServiceRequestDetailById({commit}, request_id){
            return new Promise((resolve,reject) => {
              axios.get(`${BASE_URL}/servicerequest/details/${request_id}`).then((response) => {
                commit("setRequestDetail",response.data.data)
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
        },
        addRequestDetails({},payload){
            return new Promise((resolve,reject) => {
              axios.put(`${BASE_URL}/servicerequest/add/details`,payload).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
        },
        createRequestReversePickup({},payload){
            return new Promise((resolve,reject) => {
              axios.put(`${BASE_URL}/servicerequest/pickup`,payload).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
        },
        updateRequestStatus({},payload){
            return new Promise((resolve,reject) => {
              axios.put(`${BASE_URL}/servicerequest/update/status`,payload).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
        },
        updateRequestWarranty({ dispatch },payload){
          return new Promise((resolve,reject) => {
            axios.put(`${BASE_URL}/servicerequest/warranty`,payload).then((response) => {
              dispatch("getServiceRequestDetailById", payload.request_id)
              resolve(response.data.data)
            }).catch(error => {
              reject(error.response.data)
            })
          })
        },
        updateRequestTracking({ dispatch },payload){
          return new Promise((resolve,reject) => {
            axios.put(`${BASE_URL}/servicerequest/tracking`,payload).then((response) => {
              dispatch("getServiceRequestDetailById", payload.request_id)
              resolve(response.data.data)
            }).catch(error => {
              reject(error.response.data)
            })
          })
        },
        uploadInvoice({}, uploadPayload){
            return new Promise((resolve,reject) => {
              axios.put(`${BASE_URL}/servicerequest/upload/invoice`,uploadPayload).then(async (response) => {
                await axios.put(response.data.url, uploadPayload.file, { headers: {'Content-Type': uploadPayload.file.type} })
                resolve(response.data.url.split("?Content-Type=")[0])
              }).catch(error => {
                console.log(error)
                reject(error)
              })
            })
          }
    },
    mutations: {
        setRequestListing: (state, requestListing) => (state.requestListing = requestListing),
        setRequestDetail: (state, requestDetail) => (state.requestDetail = requestDetail),
        setProductRequestListing: (state, productRequestListing) => (state.productRequestListing = productRequestListing),
        setRequestSummary: (state, requestSummary) => (state.requestSummary = requestSummary || {}),
    },
}